import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { modules } from './data/content';
import { CountdownBanner } from './components/CountdownBanner';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { SystemIntro } from './components/SystemIntro';
import { ModuleSection } from './components/ModuleSection';
import { InsidePages } from './components/InsidePages';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="23u9tmmkgrbwr">
      <noscript data-id="element-1" data-mp="3ijxpcqos80jw">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ik7jmqgv0tve" />
      </noscript>
      <CountdownBanner data-id="element-3" data-mp="3rdas0kcnegj6" />
      <Hero data-id="element-4" data-mp="3rd1bdndhtlq5" />
      <main data-id="element-5" data-mp="3recdlirailf5">
        <Testimonials data-id="element-6" data-mp="5yk6vxnnffx" />
        <Problem data-id="element-7" data-mp="6hovayao7c0" />
        <section className="bg-cream pb-16 sm:pb-20" aria-label="El sistema" data-id="element-8" data-mp="4wx1t3d72hu">
          <SystemIntro data-id="element-9" data-mp="2zllduyaeeel5" />
        </section>
        <InsidePages data-id="element-10" data-mp="2zmo7vf30ox5a" />
        <section className="bg-cream pb-20 pt-16 sm:pb-24 sm:pt-20" aria-label="Los 6 módulos" data-id="element-11" data-mp="2zng0qi58cgrv">
          <div className="mx-auto max-w-[920px] space-y-5 px-5 sm:px-8" data-id="element-12" data-mp="33oi337ug18y2">
            {modules.map(m => <ModuleSection key={m.number} module={m} data-id="element-13" data-mp="3dkuuu06fhcq6" />)}
          </div>
        </section>
        <Bonuses data-id="element-14" data-mp="nvj35ett6cp7" />
        <WhatYouGet data-id="element-15" data-mp="nw2cw89b1us5" />
        <Offer data-id="element-16" data-mp="nuhj4kutefvc" />
        <Guarantee data-id="element-17" data-mp="nv0wrpdfmi3k" />
        <Faq data-id="element-18" data-mp="nxn902b9pls4" />
        <FinalCta data-id="element-19" data-mp="sunas11342df" />
      </main>
      <Footer data-id="element-20" data-mp="studrrrxgr8h" />
    </div>;
}